module.exports = __webpack_public_path__ + "assets/icn-plugin.962f6b6d.svg";